import React from 'react'
import { ViewTypeList, ViewTypeButton } from './styles'
import { SelectViewOptions } from '~/constants'
import { EViewOptions, ViewsType } from '~/interfaces'

export interface PopoverViewTypeProps {
  selectedOption: ViewsType
  handleViewType: (viewType: ViewsType) => void
}

export const PopoverViewType = ({ selectedOption, handleViewType }: PopoverViewTypeProps): JSX.Element => {
  const viewOptions = Object.values(EViewOptions)

  return (
    <ViewTypeList>
      {viewOptions.map((option: ViewsType, index) => {
        return (
          <li key={index}>
            <ViewTypeButton onClick={() => handleViewType(option)} selected={option === selectedOption}>
              {SelectViewOptions[option]}
            </ViewTypeButton>
          </li>
        )
      })}
    </ViewTypeList>
  )
}
